export default "__VITE_ASSET__Ca9Q98ur__"